// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"IncidentList_mainContent__25akt","tableMinWidth":"IncidentList_tableMinWidth__2VaxY"};